var _path, _path2, _rect, _path3, _path4, _circle, _path5, _path6, _line, _path7, _path8, _path9, _circle2, _circle3, _path10, _circle4, _circle5, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappyFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 174,
    viewBox: "0 0 203 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.933 172.933C187.037 158.829 196.642 140.859 200.533 121.296C204.424 101.734 202.427 81.4563 194.794 63.0286C187.161 44.6009 174.235 28.8504 157.651 17.769C141.066 6.68762 121.568 0.772944 101.622 0.772944C81.6761 0.772944 62.178 6.68762 45.5935 17.769C29.009 28.8504 16.0829 44.6009 8.44993 63.0286C0.81692 81.4563 -1.18022 101.734 2.71105 121.296C6.60232 140.859 16.2072 158.829 30.3112 172.933L101.622 171.5L172.933 172.933Z",
    fill: "#F9F9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.663 155.337C162.64 145.36 169.434 132.648 172.187 118.81C174.94 104.971 173.527 90.6264 168.127 77.5905C162.728 64.5546 153.584 53.4127 141.852 45.5736C130.12 37.7345 116.327 33.5505 102.217 33.5505C88.1069 33.5505 74.3138 37.7345 62.5818 45.5736C50.8498 53.4127 41.7058 64.5546 36.3062 77.5905C30.9065 90.6264 29.4938 104.971 32.2465 118.81C34.9992 132.648 41.7938 145.36 51.771 155.337L102.217 154.324L152.663 155.337Z",
    fill: "#ECE8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 59,
    width: 98,
    height: 114,
    rx: 3,
    fill: "white",
    stroke: "#250056",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 112C94.3434 111.683 93.5639 111.431 92.706 111.26C91.8481 111.088 90.9286 111 90 111C89.0714 111 88.1519 111.088 87.294 111.26C86.4361 111.431 85.6566 111.683 85 112",
    stroke: "#EEEFF3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 112C117.343 111.683 116.564 111.431 115.706 111.26C114.848 111.088 113.929 111 113 111C112.071 111 111.152 111.088 110.294 111.26C109.436 111.431 108.657 111.683 108 112",
    stroke: "#EEEFF3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 71,
    r: 21,
    fill: "#DCF8F3",
    stroke: "#250056",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.69 68.2719C165.336 65.0948 164.015 62.1032 161.904 59.702C159.794 57.3007 156.997 55.6056 153.892 54.8463C150.787 54.0869 147.523 54.2998 144.543 55.4562",
    stroke: "#CDF1EB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.122 71.75L150.122 77.75L159.122 64.25",
    stroke: "#024945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 173,
    x2: 202,
    y2: 173,
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 45L47 53",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45L56 51",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39 62L45 62",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 105,
    r: 3,
    fill: "#250056"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 105,
    r: 3,
    fill: "#250056"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110 125C108.884 126.268 107.559 127.274 106.1 127.96C104.642 128.647 103.079 129 101.5 129C99.9214 129 98.3583 128.647 96.8998 127.96C95.4414 127.274 94.1162 126.268 93 125",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 36,
    r: 4,
    stroke: "#9747FF",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 142.5,
    r: 1.5,
    stroke: "#9747FF",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170 101L173.144 100.445L175.196 98L175.751 101.144L178.196 103.196L175.053 103.751L173 106.196L172.445 103.053L170 101Z",
    fill: "#51DDBB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6357 26.3633L79.0054 22.1231L76.5652 18.6359L80.8054 19.0056L84.2926 16.5653L83.9229 20.8055L86.3631 24.2927L82.123 23.923L78.6357 26.3633Z",
    fill: "#51DDBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/happyFace.65335b020493e93f7f740ff375005a59.svg";
export { ForwardRef as ReactComponent };